module.exports = __webpack_public_path__ + "static/media/communication.a18e43d8.svg";